import { render, staticRenderFns } from "./WidgetWrapper.vue?vue&type=template&id=8092d536&"
import script from "./WidgetWrapper.vue?vue&type=script&lang=ts&"
export * from "./WidgetWrapper.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports